import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  FILTERS_GUIDE,
  RATE_ANALYSIS_GUIDE,
  WELCOME_GUIDE,
} from '../../guides';
import { GuidedToursService, IntroJsService } from '../../services';
import { environment } from '@/environments/environment';
import { UserGuide } from '../../models/user-guide';

@Component({
  selector: 'rdo-guided-tours-management',
  templateUrl: './guided-tours-management.component.html',
  styleUrls: ['./guided-tours-management.component.scss'],
  standalone: false,
})
export class GuidedToursManagementComponent implements OnInit, OnDestroy {
  private routerSubscription!: Subscription;
  private readonly SOURCE_GUIDES: Array<UserGuide> = [
    RATE_ANALYSIS_GUIDE,
    FILTERS_GUIDE,
    WELCOME_GUIDE,
  ];
  public showContent: boolean = false;
  public showGuidedTours: boolean = false;
  public availableGuides: Array<UserGuide> = [];

  constructor(
    private router: Router,
    private introJsService: IntroJsService,
    private guidedToursService: GuidedToursService
  ) {
    this.guidedToursService.$serviceIsReady.subscribe((serviceIsReady) => {
      if (serviceIsReady) {
        this.availableGuides = this.guidedToursService.filterStepsByPermissions(
          this.SOURCE_GUIDES
        );
      }
    });
  }

  ngOnInit(): void {
    if (environment.enableUnpromptedGuidance) {
      this.setupFilterSelectionDisplay();
    }
    this.updateshowGuidedTours();
    this.routerSubscription = this.router.events
      .pipe(
        // Filter only for the event you care about (usually NavigationEnd)
        filter(
          (event: Event): event is NavigationEnd =>
            event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        this.updateshowGuidedTours();
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private updateshowGuidedTours() {
    const guidedToursEnabled = environment.enableUnpromptedGuidance;
    const currentlyInCg = this.router.url
      .toLowerCase()
      .endsWith('custom-grids');
    this.showGuidedTours = guidedToursEnabled && !currentlyInCg;
  }

  triggerGuide(guide: UserGuide) {
    this.introJsService.executeGuide(guide);
    this.showContent = false;
  }

  private setupFilterSelectionDisplay() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateshowGuidedTours();
      }
    });
  }
}
